<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

const value = computed(() => {
  if (!Array.isArray(props.data) || props.data.length === 0) return []
  return props.data
})
</script>

<template>
  <div class="table-cell flex gap-1">
    <span v-for="(item, idx) in value" class="!font-bold !text-[11px] whitespace-nowrap" :style="`color: ${item.color}`" :key="`color-cell-tag-${idx}`"> {{item.label}}</span>
  </div>
</template>

<style scoped>

</style>
